import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ChangeTitle,
  formatPrice,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import {
  deleteCookie,
  getCookie,
  setCookie,
} from "../../helpers/CookieComponent";
import { apiHeader, postData } from "../../helpers/ApiHelper";

import { ToastContainer } from "react-toastify";
import { IoClose, IoDocument } from "react-icons/io5";
import { MdContentCopy } from "react-icons/md";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";

const BooksSinglePayment = () => {
  ChangeTitle("Payment");
  const navigate = useNavigate();
  const [bookDetail, setBookDetail] = useState({});
  const [promoCode, setPromoCode] = useState("");
  const [isPromoCodeValid, setIsPromoCodeValid] = useState("");
  const [paymentMode, setPaymentMode] = useState("Online");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [promoCodeList, setPromoCodeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [liveQuantity, setLiveQuantity] = useState("");
  const booksId = getCookie("b-billingId");
  
  const currency = getCookie("b-plan-currency");
  const quantity = getCookie("b-qty");
  const addressId = getCookie("selected-shipping-address-id");
  const billingAddressId = getCookie("selected-billing-address-id");

  useEffect(() => {
    if (quantity) {
      setLiveQuantity(quantity);
    }
  }, [quantity]);

  // Function to handle incrementing quantity
  const incrementQuantity = () => {
    const updatedQty = Number(quantity) + 1;
    setLiveQuantity(updatedQty);
    setCookie("b-qty", updatedQty, {});
    viewBooksDetail(booksId, updatedQty, "", currency);
  };

  // Function to handle decrementing quantity
  const decrementQuantity = () => {
    if (liveQuantity > 1) {
      const updatedQty = Number(quantity) - 1;
      setLiveQuantity(updatedQty);
      setCookie("b-qty", updatedQty, {});
      viewBooksDetail(booksId, updatedQty, "", currency);
    }
  };

  // Plan Detail API Call
  const viewBooksDetail = async (id, qty, promoCode, currency) => {
    const param = {
      bookId: id,
      quantity: qty,
      promoCode: promoCode,
      currency: currency,
    };
    var response = await postData(
      "private/order/direct/buy/preview",
      param,
      apiHeader(false)
    );

    console.log("plan detail billing param", param);
    console.log("plan detail billing", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setBookDetail(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Plan Detail API Call
  const viewPromoCode = async (grandTotal="", currency, discount = "") => {
    const param = {
      offset: 0,
      limit: 0,
      grandTotal: +grandTotal + +discount,
      currency: currency,
    };

    var response = await postData(
      "private/promocode/user/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const listData = response.data.data.list;
      setPromoCodeList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewPromoCode(
      bookDetail &&
        bookDetail.paymentDetail &&
        bookDetail.paymentDetail.grandTotal &&
        bookDetail.paymentDetail.grandTotal.toFixed(2),
      currency,
      bookDetail &&
        bookDetail.paymentDetail &&
        bookDetail.paymentDetail.discount &&
        bookDetail.paymentDetail.discount.toFixed(2)
    );
  }, [
    bookDetail &&
      bookDetail.paymentDetail &&
      bookDetail.paymentDetail.grandTotal &&
      bookDetail.paymentDetail.grandTotal.toFixed(2),
    currency,
    bookDetail &&
      bookDetail.paymentDetail &&
      bookDetail.paymentDetail.discount &&
      bookDetail.paymentDetail.discount.toFixed(2),
  ]);

  // Purchase Plan Api call
  const addPlanPurchase = async (
    transactionId = "",
    paymentType,
    currency,
    item,
    subTotal,
    gst,
    discount = "",
    grandTotal,
    promoCodeId = "",
    addressId,
    billingAddressId,
    bookId,
    price,
    quantity
  ) => {
    if (!transactionId) {
      setLoading(true);
    }
    const param = {
      transactionId: transactionId,
      paymentType: paymentType,
      currency: currency,
      item: item,
      subTotal: subTotal,
      GST: gst,
      discount: discount,
      grandTotal: grandTotal,
      promoCodeId: promoCodeId,
      addressId: addressId,
      billingAddressId:billingAddressId,
      productDetail: [
        {
          _id: bookId,
          price: price,
          quantity: quantity,
        },
      ],
    };

    console.log("addPlanPurchase param", param);

    var response = await postData(
      "private/order/place",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      deleteCookie("b-billingId");
      deleteCookie("b-plan-currency");
      deleteCookie("b-qty");
      deleteCookie("selected-address-id");
      if (paymentType == "Online") {
        sessionStorage.setItem("paymentstatus", "success");
        navigate("/paymentstatus");
      } else {
        sessionStorage.setItem("paymentstatus", "cashondelivery");
        setTimeout(() => {
          navigate("/paymentstatus");
          setLoading(false);
        }, 2000);
      }
    } else {
      setLoading(false);
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  const openCheckout = (
    paymentType,
    currency,
    item,
    subTotal,
    gst,
    discount = "",
    grandTotal,
    promoCodeId = "",
    addressId,
    billingAddressId,
    bookId,
    price,
    quantity
  ) => {
    if (
      !paymentType ||
      !currency ||
      !item ||
      !subTotal ||
      !gst ||
      !grandTotal ||
      !addressId ||
      !billingAddressId ||
      !bookId ||
      !price ||
      !quantity
    ) {
      return;
    }

    // Define multipliers for each currency
    const currencyMultiplier = {
      INR: 100, // Indian Rupee
      USD: 100, // US Dollar
      BHD: 1000, // Bahraini Dinar
      QAR: 100, // Qatari Riyal
      OMR: 1000, // Omani Rial
      AED: 100, // UAE Dirham
    };

    // Default to 100 if the currency isn't listed
    const multiplier = currencyMultiplier[currency] || 100;

    // Calculate the base price
    const basePrice = Math.round(parseFloat(grandTotal) * multiplier);

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: basePrice,
      currency: currency,
      name: "GCC Law Help",
      // description: `Purchase`,
      image: toAbsoluteUrl("media/img/logo/main-logo.svg"),
      handler: function (response) {
        console.log(response, "Payment Response");

        if (response.razorpay_payment_id) {
          addPlanPurchase(
            response.razorpay_payment_id,
            paymentType,
            currency,
            item,
            subTotal,
            gst,
            discount,
            grandTotal,
            promoCodeId,
            addressId,
            billingAddressId,
            bookId,
            price,
            quantity
          );
        }
      },
      prefill: {
        name: "John Doe",
        email: "john.doe@example.com",
      },
      notes: {
        address: "Your Company Address",
      },
      theme: {
        color: "#F37254",
      },
    };

    const rzp = new window.Razorpay(options);
    console.log(
      "rzp",
      rzp.on((data) => {
        return data;
      })
    );

    // Listen for the 'payment.cancelled' event when the modal is closed
    rzp.on("payment.cancelled", function (response) {
      sessionStorage.setItem("paymentstatus", "cancel");
      window.location.href = "/paymentstatus";

      sessionStorage.setItem("paymentstatus", "cancel");
      window.location.href = "/gcclawhelp/paymentstatus";

      // navigate("/paymentstatus", {
      //   state: {
      //     paymentStatus: "cancel",
      //   },
      // });
    });

    rzp.on("payment.failed", function (response) {
      // navigate("/paymentstatus", {
      //   state: {
      //     paymentStatus: "failed",
      //   },
      // });
      sessionStorage.setItem("paymentstatus", "failed");
      window.location.href = "/gcclawhelp/paymentstatus";
    });

    rzp.open();
  };

  useEffect(() => {
    viewBooksDetail(booksId, quantity, "", currency);
  }, [booksId, quantity, currency]);

  // Promocode Form Submit Function
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent form submission
    viewBooksDetail(booksId, quantity, promoCode, currency);
  };

  // Opem Modal Popup Form Function
  const openModal = () => {
    if (promoCodeList.length == 0) {
      toasterrormsg("Promo Code Not Available!");
    } else if (promoCodeList.length > 0) {
      document.body.style.overflowY = "hidden";
      setIsModalOpen(true);
    }
  };
  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
  };

  return (
    <>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] h-[95vh] overflow-y-auto md:w-[80%] lg:w-[70%] xl:w-[60%]  xxl:container p-[2%] mx-auto relative top-1/2 transform -translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Available promo code</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="w-full flex flex-col gap-4">
                {promoCodeList.length > 0 &&
                  promoCodeList.map((data) => (
                    <div className="flex items-center justify-between">
                      <div>
                        <h1 className="promocode-text">{data.promoCode}</h1>
                        <h2 className="promocode-off-text">{data.title}</h2>
                      </div>
                      <button
                        className="btn btn-sm btn-light-info ms-3 table-doc-icon btn-copy-text"
                        title="Copy"
                        onClick={() => {
                          navigator.clipboard.writeText(data.promoCode);
                          toastsuccessmsg("Promo Code Copied.");
                        }}
                      >
                        {/* <MdContentCopy className="fs-3" /> */}
                        Copy
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[3%] billing-address-main">
        <div className="xxl:container mx-auto">
          <div className="w-full flex items-center justify-center lg:justify-start mb-[2%] bam-status">
            <div className="w-max bams-box">
              <div className="w-auto mx-auto mb-[10%] flex items-center justify-center px-[2%] py-[5%] text-center no">
                <h1>1</h1>
              </div>
              <div className="title">Address</div>
            </div>
            <div className="w-[50%] sm:w-[25%] md:w-[30%] lg:w-[15%] xl:w-[10%] mt-[-5%] md:mt-[-2%] bams-box-line"></div>
            <div className="w-max bams-box bams-box2">
              <div className="w-auto mx-auto mb-[5%] flex items-center justify-center px-[2%] py-[5%] text-center no">
                <h1>2</h1>
              </div>
              <div className="title">Payment</div>
            </div>
          </div>
          <div className="w-full flex flex-col lg:flex-row gap-10 choose-payment-mode">
            <div className="flex flex-col gap-10 w-full lg:w-[70%] h-max cpm-main">
              <div className="w-full p-[3%] sm:p-[2%] cpm-part">
                <div className="w-full mb-[1%] flex items-center justify-between cpmp">
                  <h1>Choose payment mode</h1>
                </div>
                <div className="w-full px-[2%] md:px-[1%] py-[2%] ba-box">
                  <div className="w-full mb-[5%] flex gap-[5%] md:gap-[10%] lg:gap-[5%] xl:gap-[10%] cpm-types">
                    {/* <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "Online" ? "cpm-type-active" : ""
                      }`}
                      onClick={() => setPaymentMode("Online")}
                    >
                      Online Payment
                    </Link> */}
                    <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "Online" ? "cpm-type-active" : ""
                      }`}
                      onClick={() => setPaymentMode("Online")}
                    >
                      NEFT / Online
                    </Link>
                    <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "COD" ? "cpm-type-active" : ""
                      }`}
                      onClick={() => setPaymentMode("COD")}
                    >
                      Cash on delivery
                    </Link>
                    <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "Cheque/Demand Draft"
                          ? "cpm-type-active"
                          : ""
                      }`}
                      onClick={() => setPaymentMode("Cheque/Demand Draft")}
                    >
                      Cheque / Demand draft
                    </Link>
                  </div>
                  {paymentMode == "Online" && (
                    <>
                      <div className="w-full mb-[5%]">
                        <img
                          className="w-[30%] md:w-[20%]"
                          src={toAbsoluteUrl("media/img/payment/Razorpay.svg")}
                          alt=""
                        />
                      </div>
                      <div className="w-full pay-btn">
                        <button
                          onClick={() =>
                            openCheckout(
                              paymentMode,
                              currency,
                              bookDetail &&
                                bookDetail.paymentDetail &&
                                bookDetail.paymentDetail.item,
                              bookDetail &&
                                bookDetail.paymentDetail &&
                                bookDetail.paymentDetail.subTotal &&
                                bookDetail.paymentDetail.subTotal.toFixed(2),
                              bookDetail &&
                                bookDetail.paymentDetail &&
                                bookDetail.paymentDetail.GST &&
                                bookDetail.paymentDetail.GST.toFixed(2),
                              bookDetail &&
                                bookDetail.paymentDetail &&
                                bookDetail.paymentDetail.discount &&
                                bookDetail.paymentDetail.discount.toFixed(2),
                              bookDetail &&
                                bookDetail.paymentDetail &&
                                bookDetail.paymentDetail.grandTotal &&
                                bookDetail.paymentDetail.grandTotal.toFixed(2),
                              bookDetail &&
                                bookDetail.paymentDetail &&
                                bookDetail.paymentDetail.promoCodeId &&
                                bookDetail.paymentDetail.promoCodeId,
                              addressId,
                              billingAddressId,
                              booksId,
                              bookDetail &&
                                bookDetail.item &&
                                bookDetail.item.price,
                              bookDetail &&
                                bookDetail.item &&
                                bookDetail.item.quantity
                            )
                          }
                          className="px-[3%] py-[2%] btn-pay"
                        >
                          {/* Pay Now {currencySymbol} */}
                          Pay now {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.grandTotal &&
                            formatPrice(bookDetail.paymentDetail.grandTotal, currency)}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="w-full p-[3%] sm:p-[2%] promo-code-part cpm-part">
                <div className="w-full mb-[1%] flex items-center justify-between pcp">
                  <h1>Have a promo code?</h1>
                </div>
                <form action="" onSubmit={handleSubmit} className="mb-[1%]">
                  <div className="w-full flex gap-2 sm:gap-5 md:gap-10 ">
                    <div className="w-[85%] pcp-input">
                      <input
                        type="text"
                        className="w-full px-[3%] py-[2%] pcpi"
                        placeholder="Enter code"
                        value={promoCode}
                        onChange={(e) => setPromoCode(e.target.value)}
                      />
                    </div>
                    <div className="w-[15%] pay-btn">
                      <button
                        type="submit"
                        onClick={() => setPromoCode}
                        className="w-full h-full btn-pay"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </form>

                <button onClick={() => openModal()} className="btn-link">
                  Available promo code
                </button>
                <div className="mt-2 error-msg">
                  <div className="">{isPromoCodeValid && isPromoCodeValid}</div>
                </div>
              </div>
            </div>
            <div className="h-max w-[90%] sm:w-[60%] lg:w-[30%] mx-auto p-[3%] sm:px-[2%] sm:py-[2.5%] lg:px-[1%] lg:py-[1.5%] cart-summary">
              <h1 className="w-full mb-[2%] cs-h1">Cart summary</h1>
              <div className="w-full flex flex-col justify-between">
                <div className="w-full px-[3%] mb-[40%] py-[3.5%] cs-box1">
                  <div className="w-full">
                    <div className="flex gap-5 mb-5">
                      <img
                        className="w-[5rem] h-[5rem]"
                        src={
                          bookDetail &&
                          bookDetail.item &&
                          bookDetail.item.bookImage
                        }
                        alt=""
                      />
                      <div>
                        <h1 className="mb-[1%]">
                          {bookDetail &&
                            bookDetail.item &&
                            bookDetail.item.title}
                        </h1>
                        <h2 className="mb-[5%]">
                          {" "}
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.item &&
                            bookDetail.item.price &&
                            formatPrice(bookDetail.item.price, currency)}{" "}
                        </h2>
                      </div>
                    </div>
                    <div className="flex justify-between items-center gap-10">
                      {/* <div className="flex items-center gap-10 csb1">
                         <CiCirclePlus className="cursor-pointer csb1-icon" />
                        <h3 className="csb1-no">
                          Quantity :{" "}
                          {bookDetail.item && bookDetail.item.quantity}
                        </h3>
                        {/* <CiCircleMinus className="cursor-pointer csb1-icon" />
                      </div> */}
                      <div className="flex items-center gap-10 csb1">
                        <CiCircleMinus
                          onClick={() => decrementQuantity()}
                          className="cursor-pointer csb1-icon"
                        />
                        <h3
                          style={{ userSelect: "none" }}
                          className="quantity csb1-no"
                        >
                          {bookDetail.item && bookDetail.item.quantity}
                        </h3>
                        <CiCirclePlus
                          onClick={() => incrementQuantity()}
                          className="cursor-pointer csb1-icon"
                        />
                      </div>
                      <div className="flex items-center gap-10 csb1p2">
                        <h3 className="csb1p2-price">
                          {/* Price: {currencySymbol} */}
                          Price: {currency}{" "}
                          {bookDetail &&
                            bookDetail.item &&
                            bookDetail.item.priceTotal &&
                            formatPrice(bookDetail.item.priceTotal, currency)}
                          /-
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex flex-col items-between cs-box2">
                  <div className="mb-auto">
                    <div className="w-full flex items-center justify-between mb-[5%] gap-5 csb2">
                      <h1 className="w-[60%] sm:w-[50%] md:w-[40%] lg:w-[90%] xl:w-[57%] csb2-title">
                        Payment details
                      </h1>
                      <div className="w-full csb2-line"></div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">Item</h1>
                        <h2 className="w-max">
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.item}
                        </h2>
                      </div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">Subtotal</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.subTotal &&
                            formatPrice(bookDetail.paymentDetail.subTotal, currency)}
                          /-
                        </h2>
                      </div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">GST @ 18%</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.GST &&
                            formatPrice(bookDetail.paymentDetail.GST, currency)}
                          /-
                        </h2>
                      </div>
                    </div>
                    {bookDetail &&
                      bookDetail.paymentDetail &&
                      bookDetail.paymentDetail.discount && (
                        <div className="w-full mb-[2%] payment-details">
                          <div className="w-full flex justify-between pd-item">
                            <h1 className="w-max">Discount</h1>
                            <h2 className="w-max">
                              {/* {currencySymbol} */}
                              {currency}{" "}
                              {formatPrice(bookDetail.paymentDetail.discount, currency)}
                              /-
                            </h2>
                          </div>
                        </div>
                      )}
                    <div className="w-full mb-[5%] payment-details">
                      <div className="w-full flex justify-between pd-item pd-item2">
                        <h1 className="w-max">Grand total</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.grandTotal &&
                            formatPrice(bookDetail.paymentDetail.grandTotal, currency)}
                          /-
                        </h2>
                      </div>
                    </div>
                  </div>
                  {paymentMode != "Online" && (
                    <div className="w-full mt-[5%] flex pay-button">
                      <button
                        className="w-full py-[5%] btn-pay"
                        onClick={() => {
                          addPlanPurchase(
                            "",
                            paymentMode,
                            currency,
                            bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.item,
                            bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.subTotal &&
                              bookDetail.paymentDetail.subTotal.toFixed(2),
                            bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.GST &&
                              bookDetail.paymentDetail.GST.toFixed(2),
                            bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.discount &&
                              bookDetail.paymentDetail.discount.toFixed(2),
                            bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.grandTotal &&
                              bookDetail.paymentDetail.grandTotal.toFixed(2),
                            bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.promoCodeId &&
                              bookDetail.paymentDetail.promoCodeId,
                            addressId,
                            billingAddressId,
                            booksId,
                            bookDetail &&
                              bookDetail.item &&
                              bookDetail.item.price,
                            bookDetail &&
                              bookDetail.item &&
                              bookDetail.item.quantity
                          );
                        }}
                        disabled={loading}
                      >
                        {!loading && (
                          <>
                            {" "}
                            Process to pay {currency}{" "}
                            {bookDetail &&
                              bookDetail.paymentDetail &&
                              bookDetail.paymentDetail.grandTotal &&
                              formatPrice(bookDetail.paymentDetail.grandTotal, currency)}
                          </>
                        )}
                        {loading && (
                          <div className="flex items-center justify-center gap-3">
                            <span className="" style={{ display: "block" }}>
                              Please wait...{" "}
                            </span>
                            <ClipLoader
                              color={"#ffffff"}
                              loading={loading}
                              size={20}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                            />
                          </div>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BooksSinglePayment;
